import React, { useEffect, useState } from 'react';
import HomeLf from './HomeLf';
import './projetos.css';
import { db, firebaseAuth } from '../utils/firebase-config';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { collection, doc, getDocs, updateDoc } from 'firebase/firestore';
import Background from 'three/examples/jsm/renderers/common/Background.js';
import { Center } from '@react-three/drei';
import axios from 'axios';

import logo from '../assets/version2/logo.png'

import listicon from "../assets/version2/listicon.png";
import gridicon from "../assets/version2/gridicon.png";
import atentionicon from "../assets/version2/atentionicon.png";
import msgred from "../assets/version2/msgred.png";
import upload3d from "../assets/version2/upload3d.png";
import boxpendencias from "../assets/version2/boxpendencias.png";
import editarprojeto from "../assets/version2/editarprojeto.png";
import colaboradores from "../assets/version2/colaboradores.png";


function Conta(params) {

  const navigate = useNavigate();


  const [current, setCurrent] = useState('');
  const [dataA, setDataA] = useState([]);
  const [filtrados, setFiltrados] = useState([]);
  const [hide, setHide] = useState('none');
  const [target, setTarget] = useState([]);

  const [editData, setEditData] = useState([]);



const [aberto, setAberto] = useState('none');
const [projetoNome, setProjetoNome] = useState('');
const [descricao, setDescricao] = useState('');
const [comentariosIniciais, setComentariosIniciais] = useState('');

const [concluidos, setConcluidos] = useState(0);
const [emAndamento, setEmAndamento] = useState(0);
const [editTarget, setEditTarget] = useState('');
const [usuarioTarget, setUsuarioTarget] = useState([]);


  const [countMp, setCountMp] = useState(1);
  const [mapeA, setMapeA] = useState([1]);



  var trad = [];



  const [colaboradoresData, setColaboradoresData] = useState([]);

var count01 = 0;



async function master(params) {

      

  var objMaster = [];
  var objMaster2 = [];

   






}






















  async function finishMaster() {
   
    
        await updateDoc(doc(db, 'projetos', editTarget), {
            
      
                nomeDoProjeto: projetoNome,
                descricao: descricao,
                comentariosIniciais: comentariosIniciais,
               
          });
         
          
          
           window.location.reload();
          

    }
















useEffect(()=> {
  master();
  getDatas();
},[])




function mapear() {
            
  setCountMp(countMp + 1);

  for (let i = 0; i < countMp; i++) {
      trad.push(i);
      
  }
  trad.push(countMp);
//  console.log(trad);
  setMapeA(trad);
}




async function getDatas(params) {
    

  onAuthStateChanged(firebaseAuth, async (currentUser) => {
    if (currentUser) {
      var usuarioLogado = currentUser.email;
      setCurrent(usuarioLogado);
      
  fetch('https://apilumera.shop/api/consultausuario', {
    method: 'POST',
    body: JSON.stringify({

      email: usuarioLogado
   
    }),
    headers: {
      'Content-type': 'application/json; charset=UTF-8',
    },
  })
     .then((response) => response.json())
     .then((data) => {

      setUsuarioTarget(data)
      console.log('DATAAAAAAAAAAAA', data);
      setColaboradoresData(data.colaboradores)
      
   
     })
     .catch((err) => {
        console.log(err.message);
     });

      

 var objMaster2 = [];






        await getDocs(collection(db, "projetos"))
            .then((querySnapshot)=>{               
                const newData = querySnapshot.docs
                    .map((doc) => ({...doc.data(), id:doc.id }));
                    for (let i = 0; i < newData.length; i++) {                     
                           objMaster2.push(newData[i]);                     
                    }
                var contas = [];           
                      var arraya = [...Object.values(objMaster2)];           
                    var criados = [];          
                    var final = 0;             
                    var andamento = 0;             
                    var emailatual = firebaseAuth.currentUser.email;
                    for (let i = 0; i < arraya.length; i++) {                                           
                   if(arraya[i].criador == emailatual){
                      criados.push(arraya[i]);
                   }
                      }


                          for (let i = 0; i < criados.length; i++) {                                           
                   if(criados[i].andamento == false){
                      final = final + 1;
                   } else {
                    andamento = andamento + 1;
                   }
                      }

                      setConcluidos(final);
                       setEmAndamento(andamento);
                      console.log('asdasd',final);

                      criados.sort(function(a, b) {

                        return a.nomeDoProjeto.localeCompare(b.nomeDoProjeto);
                    
                    });



                    setFiltrados(criados);
                    console.log(criados);
              //      console.log('nova data', new Date(criados[0].dataDeCriacao.seconds*1000))
            })









































    };
  });





}








 async function enviarColaborador() {
  
  var objj = colaboradoresData;

  console.log('objj ', objj);
  function mast(params) {
    for (let i = 0; i < objj.length; i++) {
     if(objj[i].split('#io71239923')[0].replaceAll(' ', '') == params) {
         return objj[i];
     }
  }  
  }





var colaboradoresTrade = []
for (let i = 0; i < document.querySelectorAll('.dastasColaboradores').length; i++) {
colaboradoresTrade.push(`${mast(document.querySelectorAll('.dastasColaboradores')[i].querySelectorAll('select')[0].value).split('#io71239923')[1] } ###master ${mast(document.querySelectorAll('.dastasColaboradores')[i].querySelectorAll('select')[0].value).split('#io71239923')[2].replaceAll(' ', '')} ###master ${document.querySelectorAll('.dastasColaboradores')[i].querySelectorAll('select')[1].value} ###master ${document.querySelectorAll('.dastasColaboradores')[i].querySelectorAll('select')[0].value}`) 
}

//console.log(colaboradoresTrade);

var tradeEmails = []
for (let i = 0; i < colaboradoresTrade.length; i++) {
    tradeEmails.push(colaboradoresTrade[i].split('###master')[0].replaceAll(' ', ''))
}





await fetch('https://apilumera.shop/api/vincularcolaborador', {
  method: 'POST',
  body: JSON.stringify({
    colaboradores: colaboradoresTrade,
      emails: tradeEmails,
      target: target

  }),
  headers: {
    'Content-type': 'application/json; charset=UTF-8',
  },
})
   .then((response) => response.json())
   .then((data) => {
      console.log(data);


   })
   .catch((err) => {
      console.log(err.message);
   });



  
















 }














    return (
      <>
      
      











<div style={{backgroundColor: 'rgba(100,100,100,0.5)', width: '100%', height: '100%', position: 'absolute',
display: aberto, justifyContent: 'center', alignItems: 'center'

}}>


<div style={{ width: '500px',borderRadius: '16px', backgroundColor: '#fff', paddingBottom: '30px'}}>
<div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: '10px',
paddingLeft: '20px', paddingRight: '20px',
alignItems: 'center'

}}>
<div><img src={logo} style={{width: '120px'}}></img></div>
<div style={{cursor: 'pointer'}}
onClick={()=> {setAberto('none');
                      document.querySelector('.editInputTitle').value = '';
                      document.querySelector('.editInputDescricao').value = '';
                      document.querySelector('.editInputInfos').value = '';
}}
>    <i class="bi bi-x" style={{fontSize: '25px'}}
/>
</div>

</div>
<div>

<div className="row" style={{ width: '100%', padding: '0px 30px', height: '35px', marginTop: '15px'}}>
<div className="col-6" style={{borderRadius: '10px 0px 0px 10px', display: 'flex', fontSize: '14px', justifyContent: 'center', alignItems: 'center', backgroundColor: '#985EAC', color: '#fff'}}>Novo Projeto</div>
<div className="col-6" style={{borderRadius: '0px 10px 10px 0px', display: 'flex', fontSize: '14px', justifyContent: 'center', alignItems: 'center', backgroundColor: 'rgba(100,100,100,0.1)', color: 'black'}}>Colaboradores</div>
</div>

<div style={{padding: '0px 30px', marginTop: '30px'}}>
<div style={{fontWeight: 'bold', marginBottom: '6px'}}>Título do Projeto</div>
<input className='editInputTitle' style={{border: '1px solid #fff', backgroundColor: 'rgba(200,200,200, 0.2)', width: '100%', height: '35px', borderRadius: '10px', padding: '0px 14px'}} placeholder="Insira o título do projeto"
  onChange={(e) => setProjetoNome(e.target.value)  }
></input>
</div>


<div style={{padding: '0px 30px', marginTop: '20px'}}>
<div style={{fontWeight: 'bold', marginBottom: '6px'}}>Descrição do Projeto</div>
<input className='editInputDescricao' style={{border: '1px solid #fff', backgroundColor: 'rgba(200,200,200, 0.2)', width: '100%', height: '35px', borderRadius: '10px', padding: '0px 14px'}} placeholder="Insira a descrição do projeto"
  onChange={(e) => setDescricao(e.target.value)  }
></input>
</div>




<div style={{padding: '0px 30px', marginTop: '20px'}}>
<div style={{fontWeight: 'bold', marginBottom: '6px'}}>informações do Projeto</div>
<input className='editInputInfos' style={{border: '1px solid #fff', backgroundColor: 'rgba(200,200,200, 0.2)', width: '100%', height: '35px', borderRadius: '10px', padding: '0px 14px'}} placeholder="Insira informações do projeto"
  onChange={(e) => setComentariosIniciais(e.target.value)  }
></input>
</div>

<div style={{padding: '0px 30px', marginTop: '20px'}}>
<div style={{fontWeight: 'bold', marginBottom: '6px'}}>informações do Projeto</div>
<a style={{cursor: 'pointer', textDecoration: 'underline'}}
onClick={()=> navigate(`/uploadmaster?idproject=${editTarget}`)}
>Atualizar arquivo 3D</a>
</div>










<div style={{display: 'flex', justifyContent: 'end', alignItems: 'center', width: '100%', padding: '0px 30px', marginTop: '28px'}}>
        <div style={{cursor: 'pointer', width: '150px', height: '35px', borderRadius: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: '600', color: '#fff', backgroundColor: '#985EAC'}}
        onClick={()=> finishMaster()}
        >Editar Projeto </div>
</div>

</div>









</div>

</div>
































































 
      
      
      
      
      
      
      
      
        <div>



<HomeLf/>


<div
  className="col-12"
  style={{
    display: "flex",
    flexFlow: "row nowrap",
    justifyContent: "center",
    marginTop: 50
  }}
>
  <div className="col-10">
    <div>
      <div style={{ marginBottom: 40 }}>
        <h2 className="meusProjetos">{usuarioTarget.nome} </h2>
      </div>
      <div
        style={{
          display: "flex",
          flexFlow: "row nowrap",
          justifyContent: "space-around",
          marginBottom: 50
        }}
      >
        <div style={{ display: "flex", flexFlow: "column nowrap" }}>
          <div className="tituloCards">Quantos Projetos Participei</div>
          <a className="numerosCards">{filtrados.length}</a>
        </div>
        <div
          style={{
            display: "flex",
            flexFlow: "column nowrap",
            paddingLeft: "7rem",
            borderLeft: "1px solid #BDC1CA",
            borderRight: "1px solid #BDC1CA",
            paddingRight: "7rem"
          }}
        >
          <div className="tituloCards" style={{ display: "flex" }}>
            Projetos:{" "}
            <div>
              <a className="emAndamento"> Em Andamento</a>
            </div>
          </div>
          <a className="numerosCards">{emAndamento}</a>
        </div>
        <div style={{ display: "flex", flexFlow: "column nowrap" }}>
          <div className="tituloCards" style={{ display: "flex" }}>
            Projetos:{" "}
            <div>
              <a className="concluido"> Concluído</a>
            </div>
          </div>
          <a className="numerosCards">{concluidos}</a>
        </div>
      </div>
    





                <div style={{ marginTop: 20, marginBottom: '100px' }}>
     
        <div
          style={{
            border: "1px #DEE1E6 solid",
            borderRadius: 12,
            padding: 18,
           paddingBottom: '20px'
          }}
          className="d-flex"
        >
          <div className="col-8" style={{ borderRight: "1px solid #DEE1E6" }}>
            <div className="principalTitle" style={{ marginBottom: 10 }}>
              Dados da conta
            </div>
            <div className="descricoes" style={{ display: "flex", marginTop: '25px' }}>
              <div style={{ marginRight: 10 }}>
                {" "}
                <img style={{ paddingBottom: 3 }} src={atentionicon} />
              </div>
             <a style={{fontWeight: '700'}}>Nome: <a style={{fontWeight: '200'}}>{usuarioTarget.nome}</a></a> 
            </div>

    


       

            
          <div
              className="descricoes"
              style={{ display: "flex", marginTop: 10 }}
            >
              <div style={{ marginRight: 10 }}>
              
                <img style={{ paddingBottom: 3, marginRight: '10px' }} src={atentionicon} />
{usuarioTarget.colaboradores != undefined && 
<>
              <a style={{fontWeight: '700'}}>Data de criação: <a style={{fontWeight: '200'}}>{usuarioTarget.criacao.split('T')[0]}</a></a>
</>
}
             
              </div>
             
            </div>







         <div
              className="descricoes"
              style={{ display: "flex", marginTop: 10 }}
            >
              <div style={{ marginRight: 10 }}>
              
                <img style={{ paddingBottom: 3, marginRight: '10px' }} src={atentionicon} />
{usuarioTarget.empresa != undefined && 
<>
              <a style={{fontWeight: '700'}}>Empresa: <a style={{fontWeight: '200'}}>{usuarioTarget.empresa}</a></a>
</>
}
             
              </div>
             
            </div>



       <div
              className="descricoes"
              style={{ display: "flex", marginTop: 10 }}
            >
              <div style={{ marginRight: 10 }}>
              
                <img style={{ paddingBottom: 3, marginRight: '10px' }} src={atentionicon} />
{usuarioTarget.email != undefined && 
<>
              <a style={{fontWeight: '700'}}>Email: <a style={{fontWeight: '200'}}>{usuarioTarget.email}</a></a>
</>
}
             
              </div>
             
            </div>



   <div
              className="descricoes"
              style={{ display: "flex", marginTop: 10 }}
            >
              <div style={{ marginRight: 10 }}>
              
                <img style={{ paddingBottom: 3, marginRight: '10px' }} src={atentionicon} />
{usuarioTarget.admin != undefined && 
<>
              <a style={{fontWeight: '700'}}>Admin: <a style={{fontWeight: '200'}}>{usuarioTarget.admin ? 'Sim' : 'Não'}</a></a>
</>
}
             
              </div>
             
            </div>





{usuarioTarget.colaboradores != undefined && 
<>
{usuarioTarget.colaboradores.map((data, index) => {
  return <>
  
          <div
              className="descricoes"
              style={{ display: "flex", marginTop: 10 }}
            >
              <div style={{ marginRight: 10 }}>
              
                <img style={{ paddingBottom: 3, marginRight: '10px' }} src={atentionicon} />
           <a style={{fontWeight: '700'}}>Colaborador {index+1}: <a style={{fontWeight: '200'}}>{data.split('#io71239923')[0].replaceAll(' ', '')+', '+data.split('#io71239923')[1]}</a></a>   
              </div>
             
            </div>
  
  
  </>
})}
</>
}








{usuarioTarget.disciplinas != undefined && 
<>
{usuarioTarget.disciplinas.map((data, index) => {
  return <>
  
          <div
              className="descricoes"
              style={{ display: "flex", marginTop: 10 }}
            >
              <div style={{ marginRight: 10 }}>
              
                <img style={{ paddingBottom: 3, marginRight: '10px' }} src={atentionicon} />
               <a style={{fontWeight: '700'}}>Disciplina {index+1}: <a style={{fontWeight: '200'}}>{data}</a></a>

              </div>
             
            </div>
  
  
  </>
})}
</>
}

<button style={{backgroundColor: 'rgb(98, 98, 98)', borderColor: 'transparent', color: 'white', padding: '5px 20px', borderRadius: '10px', marginTop: '20px'}}
onClick={()=> signOut(firebaseAuth)}
>Deslogar</button>










          </div>
         
        </div>
      </div>
         
    



    </div>
  </div>
</div>









        </div>
        </>
    )
}
export default Conta;